import BackButton from 'components/BackButton';
import RoundedButton, { ColorStyle } from 'components/RoundedButton';
import React from 'react';
import { ASSET_PREFIX, colors } from 'utils/constants';

export const CANCELLATION_FLOW_IMG_DIR = `${ASSET_PREFIX}/images/subscriptions/cancellation-flow`;

const CancellationFlowStep = ({
  icon,
  heading,
  primaryCTAText,
  primaryCTAOnClick,
  primaryCTADisabled,
  primaryCTALoading,
  secondaryCTAText = 'No, cancel subscription',
  secondaryCTAOnClick,
  secondaryCTADisabled,
  secondaryCTALoading,
  onGoBack,
  children,
}: {
  icon: string;
  heading: React.ReactNode;
  primaryCTAText?: string;
  primaryCTAOnClick?: () => void;
  primaryCTADisabled?: boolean;
  primaryCTALoading?: boolean;
  secondaryCTAText?: string;
  secondaryCTAOnClick?: () => void;
  secondaryCTADisabled?: boolean;
  secondaryCTALoading?: boolean;
  onGoBack?: () => void;
  children: React.ReactNode;
}) => {
  const showPrimaryCTA = primaryCTAText && primaryCTAOnClick;
  const showSecondaryCTA = secondaryCTAOnClick;
  return (
    <div className="cancellationFlowStep fullWidth flexCentered">
      <img
        className="icon"
        src={`${CANCELLATION_FLOW_IMG_DIR}/${icon}.svg`}
        alt=""
      />

      <h4 className="heading">{heading}</h4>

      <div className="childrenContainer fullWidth flexCentered">{children}</div>

      {(showPrimaryCTA || showSecondaryCTA) && (
        <div className="ctaContainer">
          {showPrimaryCTA && (
            <RoundedButton
              onClick={primaryCTAOnClick}
              disabled={primaryCTADisabled}
              loading={primaryCTALoading}
            >
              {primaryCTAText}
            </RoundedButton>
          )}

          {showSecondaryCTA && (
            <RoundedButton
              onClick={secondaryCTAOnClick}
              colorStyle={ColorStyle.Outline}
              disabled={secondaryCTADisabled}
              loading={secondaryCTALoading}
            >
              {secondaryCTAText}
            </RoundedButton>
          )}
        </div>
      )}

      {onGoBack && <BackButton onClick={onGoBack} />}

      <style jsx>
        {`
          .cancellationFlowStep {
            padding: 2.5em 0.5em 0;
            text-align: center;
          }

          .icon {
            width: 50px;
            height: 50px;
          }

          .cancellationFlowStep h4 {
            text-transform: none;
            letter-spacing: 0;
            font-size: 1.4em;
            font-weight: 800;
            margin: 1.5em 0 1em;
          }

          .cancellationFlowStep h4:empty {
            margin-bottom: 0;
          }

          .ctaContainer {
            margin-top: 2em;
            width: 100%;
          }

          :global(.cancellationFlowStep p) {
            font-size: 1.1em;
          }

          :global(.cancellationFlowStep strong) {
            font-weight: 800;
          }

          :global(.cancellationFlowStep a:not(.backButton)) {
            font-weight: 800;
            text-decoration: underline;
            white-space: normal;
          }

          :global(.cancellationFlowStep .roundedButton) {
            width: 95%;
            margin: 0.5em;
          }

          :global(.cancellationFlowImage) {
            border-radius: 8px;
          }

          :global(.cancellationFlowImageObjectFitCover) {
            object-fit: cover;
          }

          :global(.cancellationFlowImageWrapper) {
            width: 100%;
            margin: 0.5em 0 1.5em;
          }

          :global(.cancellationFlowImageWrapper.halfWidth) {
            width: 48%;
          }

          :global(.cancellationFlowStep textarea) {
            margin-top: 0.5em;
            width: 95%;
            height: 70px;
            resize: none;
            border-radius: 6px;
            border: 2px solid #e1e1e1;
            padding: 10px;
            font-size: 1em;
            font-family: 'Montserrat', sans-serif !important;
            font-weight: 600;
            color: ${colors.primaryBrandGray};
          }

          :global(.cancellationFlowStep textarea::placeholder) {
            color: #e1e1e1;
            font-style: italic;
          }

          @media (min-width: 500px) {
            .cancellationFlowStep {
              padding: 2.5em 1em 0;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CancellationFlowStep;
